import type { CMSColumn } from '../schemas';
import { match } from 'ts-pattern';
import { CMSColumnsStandard } from '../cms-columns-standard';
import { CMSColumnsCarousel } from '../cms-columns-carousel';

interface CMSColumnsProps {
  className?: string;
  columnsData: CMSColumn;
  isFromBannerWithImage?: boolean;
}
const CMSColumns = ({
  columnsData,
  className,
  isFromBannerWithImage = false,
}: CMSColumnsProps) => {
  return match(columnsData.columns_type.key)
    .with('standard', () => {
      return <CMSColumnsStandard data={columnsData} className={className} />;
    })
    .with('carousel', () => {
      return (
        <CMSColumnsCarousel
          isFromBannerWithImage={isFromBannerWithImage}
          data={columnsData}
          className={className}
        />
      );
    })
    .otherwise(() => null);
};
export { CMSColumns };
